export const ZERO_REWARD_REFERRAL_DISCLOSURE =
  "The person who has referred you to us will not be paid any referral commissions. For more details, please reach out to us.";

export function isZeroRewardReferral(reward: number | string): boolean {
  return Number(reward) === 0;
}

export function getSignupReferralDisclosureMessage(name: string, reward: number): string {
  if (isZeroRewardReferral(reward)) {
    return ZERO_REWARD_REFERRAL_DISCLOSURE;
  }

  return `You have been referred by ${name}. The Referral Partner will receive ${reward}% of the fee that Caleb & Brown receives from each trade that you successfully complete. Payment is made from our fee and does not increase the amount payable by you.`;
}

export const REFERRAL_CODE_ONE_TIME_SUBMISSION_NOTE =
  "Please note, this referral code can only be submitted once and cannot be changed once submitted.";

export function getReferralCodeEntryDisclosureMessage(name: string, reward: number): string {
  if (isZeroRewardReferral(reward)) {
    return `${ZERO_REWARD_REFERRAL_DISCLOSURE} ${REFERRAL_CODE_ONE_TIME_SUBMISSION_NOTE}`;
  }

  return `You have been referred by ${name}. The Referral Partner will receive ${reward}% of the fee that Caleb & Brown receives from each trade that you successfully complete. Payment is made from our fee and does not increase the amount payable by you. ${REFERRAL_CODE_ONE_TIME_SUBMISSION_NOTE}`;
}

export function getLandingPageReferralDisclosureMessage(
  name: string | null,
  rewards: string,
): string {
  if (isZeroRewardReferral(rewards)) {
    return ZERO_REWARD_REFERRAL_DISCLOSURE;
  }

  return `${name ?? "The person"} who has referred you to us will be paid ${rewards}% of the fee we receive from each trade that you successfully complete. Payment is made from our fee and does not increase the amount payable by you. For more details, please reach out to us.`;
}
